import { render } from "./form-manage-document.vue?vue&type=template&id=f04f7e40"
import script from "./form-manage-document.vue?vue&type=script&lang=js"
export * from "./form-manage-document.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__